const ASCII_PUNCTUATION_REPLACEMENTS = [
  [/[\u2018\u2019\u201A\u201B]/g, "'"],
  [/[\u201C\u201D\u201E\u201F]/g, '"'],
  [/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-'],
  [/\u2026/g, '...'],
  [/[\u2022\u00B7]/g, '-'],
];

export function sanitizeCreditorMatrixText(value = '') {
  let text = String(value ?? '').replace(/\r\n?/g, '\n');
  ASCII_PUNCTUATION_REPLACEMENTS.forEach(([pattern, replacement]) => {
    text = text.replace(pattern, replacement);
  });

  // CM/ECF creditor matrices are safest as plain printable ASCII. NFKD keeps
  // readable equivalents such as "Jose" while removing unsupported accents.
  text = text
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '');
  text = [...text]
    .filter(character => {
      const code = character.charCodeAt(0);
      return character === '\n' || (code >= 32 && code <= 126);
    })
    .join('');

  return text
    .split('\n')
    .map(line => line.replace(/[\t ]+/g, ' ').trim())
    .join('\n');
}

function cleanLine(value) {
  return sanitizeCreditorMatrixText(value).replace(/\n+/g, ' ').trim();
}

function addressBlock(name, street1, street2, city, state, zipCode) {
  const lines = [name, street1].map(cleanLine).filter(Boolean);
  const secondAddressLine = cleanLine(street2);
  if (secondAddressLine) lines.push(secondAddressLine);

  const cityState = [city, state]
    .map(cleanLine)
    .filter(Boolean)
    .join(', ');
  const finalLine = [cityState, cleanLine(zipCode)]
    .filter(Boolean)
    .join(' ');
  if (finalLine) lines.push(finalLine);

  return lines.join('\n');
}

export function buildCreditorsText(creditors = []) {
  const blocks = creditors.flatMap(creditor => {
    const entries = [];
    const creditorAddress = addressBlock(
      creditor.name,
      creditor.street1,
      creditor.street2,
      creditor.city,
      creditor.state,
      creditor.zip_code,
    );
    if (creditorAddress) entries.push(creditorAddress);

    if (cleanLine(creditor.codebtor)) {
      const codebtorAddress = addressBlock(
        creditor.codebtor,
        creditor.codebtor_street1,
        creditor.codebtor_street2,
        creditor.codebtor_city,
        creditor.codebtor_state,
        creditor.codebtor_zip_code,
      );
      if (codebtorAddress) entries.push(codebtorAddress);
    }

    return entries;
  });

  return sanitizeCreditorMatrixText(blocks.join('\n\n'));
}

export function buildCreditorsTextBlob(creditors = []) {
  return new Blob([buildCreditorsText(creditors)], {
    type: 'text/plain;charset=us-ascii',
  });
}
